import React from 'react';
import { Box, keyframes, Typography } from '@mui/material';

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.6; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1.05); }
`;

/**
 * A simple yet trendy minimalist loader with a sleek gradient spinner.
 */
const MainLoader = ({ size = 40, text = "Loading", color = '#20229bff' }) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            p: 2
        }}>
            <Box sx={{ position: 'relative', width: size, height: size }}>
                {/* Subtle outer glow */}
                <Box sx={{
                    position: 'absolute',
                    inset: -4,
                    borderRadius: '50%',
                    background: `radial-gradient(circle, ${color}15 0%, transparent 70%)`,
                    animation: `${pulse} 2s ease-in-out infinite`
                }} />

                {/* Minimalist Gradient Ring */}
                <Box sx={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '50%',
                    padding: '3px',
                    background: `conic-gradient(from 0deg, transparent 30%, ${color})`,
                    WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 3px), #fff 0)',
                    mask: 'radial-gradient(farthest-side, transparent calc(100% - 3px), #fff 0)',
                    animation: `${rotate} 0.8s linear infinite`
                }} />

                {/* Pulsing Center Dot */}
                {/* <Box sx={{
                    position: 'absolute',
                    inset: '35%',
                    bgcolor: color,
                    borderRadius: '50%',
                    opacity: 0.8,
                    animation: `${pulse} 1.5s ease-in-out infinite`
                }} /> */}
            </Box>

            {text && (
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: 600,
                        color: '#64748b',
                        fontSize: '0.75rem',
                        letterSpacing: '0.05em',
                        fontFamily: "'Open Sans', sans-serif",
                        opacity: 0.8
                    }}
                >
                    {text}...
                </Typography>
            )}
        </Box>
    );
};

export default MainLoader;
